import React from 'react';

import { useTranslation } from 'react-i18next';

import { CurrencyDisplay, type CurrencyDisplayProps, TimedAction } from '@pkg/components';
import { ChipColor, ChipSize } from '@pkg/components/Sections/Profile/Chip';
import { ChipMember, type ChipMemberProps } from '@pkg/components/Sections/Profile/Chips/ChipMember';
import { FloorGameIncomingEvent } from '@pkg/types/floorGame';

import { KeywordMarquee } from './components';

import { HackChipWrapper, Section, StyledIncoming } from './styles';

type SaleValue = Pick<CurrencyDisplayProps, 'currency' | 'price' | 'localConversion'>;

export interface IncomingProps {
    activity: FloorGameIncomingEvent;
    yat?: ChipMemberProps['yat'];
    twitter?: ChipMemberProps['twitter'];
    saleValue?: SaleValue;
    compact?: boolean;
    // TODO: Do we need to offer a `onShare()` prop?
}

export function Incoming({ activity, yat, twitter, saleValue, compact = false }: IncomingProps) {
    const { t: translate } = useTranslation('floorgame');

    const chipMemberMarkup = yat?.length ? (
        <HackChipWrapper>
            <ChipMember
                yat={yat}
                twitter={twitter}
                color={ChipColor.BlurDark}
                size={compact ? ChipSize.Smaller : ChipSize.Small}
            />
        </HackChipWrapper>
    ) : null;

    const currencyDisplayMarkup =
        activity === FloorGameIncomingEvent.Sale && saleValue ? (
            <CurrencyDisplay
                compact
                symbol
                currency={saleValue.currency}
                price={saleValue.price}
                label={saleValue.localConversion ? translate('price_game_label') : undefined}
                localConversion={saleValue.localConversion}
            />
        ) : null;

    const keywordMarqueeMarkup =
        activity !== FloorGameIncomingEvent.Sale ? <KeywordMarquee activity={activity} /> : null;

    // TODO: Figure out how the "share this moment" works.
    const shareUrl = 'https://y.at/';

    return (
        <StyledIncoming $compact={compact}>
            <Section $compact={compact}>
                {chipMemberMarkup}
                {currencyDisplayMarkup}
                {keywordMarqueeMarkup}
            </Section>

            <Section $compact={compact} $center>
                <TimedAction
                    label={translate('share_moment_cta')}
                    ariaLabel={translate('share_moment_a11y')}
                    compact={compact}
                    url={shareUrl}
                    external
                />
            </Section>
        </StyledIncoming>
    );
}
